// export const baseURL = "https://back-mailer.msit-demo.fr";
// export const baseURL = "http://localhost:5000";
export const baseURL = "https://api.msit-mailing.fr";
export const localUrl = "http://localhost:3000";
